module.exports = __webpack_public_path__ + "img/mapexcel.26dd2c6c.jpg";